import service from "services/maintenance/taxScheduleService";
import TaxScheduleForm from "features/maintenance/components/DedicatedForms/TaxScheduleForm";
import { EventNoteOutlined } from "@mui/icons-material";
import MAINTENANCE_STORE_SELECTORS from "features/maintenance/dataStore/selectors";
import PAYROLL_CONSTANTS from "utils/constants/payroll";

const isEditing = (formData) => {
    return !!formData?.id;
};

const frequencyOptions = Object.values(PAYROLL_CONSTANTS.PAYROLL_FREQUENCY).map(
    (values) => ({
        value: values.id,
        label: values.description
    })
);

const taxScheduleResource = {
    title: "Tax Schedule",
    singular: "Tax Schedule",
    displayField: "Tax Schedule",
    editableForm: TaxScheduleForm,
    pageIcon: EventNoteOutlined,
    setter: MAINTENANCE_STORE_SELECTORS.TAX_SCHEDULE,
    service: service,
    actions: { noDelete: true },

    columns: [
        {
            field: "scheduleName",
            header: "Schedule Name"
        },
        {
            field: "frequency",
            header: "Frequency",
            type: "select",
            options: frequencyOptions
        },
        {
            field: "effectiveDate",
            header: "Effective Date",
            type: "date"
        }
    ],

    fields: [
        {
            name: "scheduleName",
            label: "Schedule Name",
            type: "text",
            required: true,
            unique: true
            // disabledResolver: isEditing
        },
        {
            name: "frequency",
            label: "Frequency",
            type: "select",
            required: true,
            options: frequencyOptions
            // disabledResolver: isEditing
        },
        {
            name: "effectiveDate",
            label: "Effective Date",
            type: "date",
            required: true
            // disabledResolver: isEditing
        }
    ],
    searchFields: ["scheduleName"]
};

export default taxScheduleResource;
